import { Loader, Modal } from '@mantine/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { DocumentViewer } from 'react-documents';
import Button from '../../components/elements/Button';
import { getExtensionFromUrl } from '../../utils/format';
import styles from './detail.scoped.css';

export default function DocumentPreviewModal({
  fileUrl,
  isLoading,
  onClose,
  opened,
}) {
  const extension = getExtensionFromUrl(fileUrl || '');
  const isImage = ['jpg', 'jpeg', 'png'].includes(extension);
  const isPdf = extension === 'pdf';
  const [activeFrameUrl, setActiveFrameUrl] = useState('');

  useEffect(() => {
    let timeoutId;

    if (opened && fileUrl && isPdf) {
      setActiveFrameUrl('');
      timeoutId = window.setTimeout(() => {
        setActiveFrameUrl(fileUrl);
      }, 0);
    } else {
      setActiveFrameUrl('');
    }

    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [fileUrl, isPdf, opened]);

  const renderPreview = () => {
    if (isLoading) {
      return (
        <div className={styles.previewState}>
          <Loader color="green" />
        </div>
      );
    }

    if (!fileUrl) {
      return (
        <div className={styles.previewState}>
          Dokumen pendukung tidak ditemukan.
        </div>
      );
    }

    if (isImage) {
      return <img alt="Dokumen Pendukung" className={styles.previewImage} src={fileUrl} />;
    }

    if (isPdf) {
      if (!activeFrameUrl) {
        return (
          <div className={styles.previewState}>
            <Loader color="green" />
          </div>
        );
      }

      return (
        <iframe
          className={styles.previewFrame}
          key={activeFrameUrl}
          src={activeFrameUrl}
          title="Dokumen Pendukung"
        />
      );
    }

    return (
      <DocumentViewer
        className={styles.previewDocs}
        style={{ width: '100%', height: '100%' }}
        url={fileUrl}
        viewer={['doc', 'docx'].includes(extension) ? 'office' : 'url'}
      />
    );
  };

  return (
    <Modal
      centered
      onClose={onClose}
      opened={opened}
      size="68rem"
      styles={{
        body: {
          padding: '0 0.875rem 0.875rem',
        },
        title: {
          fontSize: 20,
          fontWeight: 600,
        },
      }}
      title="Dokumen Pendukung"
    >
      <div className={styles.previewShell}>
        <div className={styles.previewPaper}>{renderPreview()}</div>
        <Button
          className={styles.previewCloseButton}
          fullWidth
          onClick={onClose}
        >
          Tutup
        </Button>
      </div>
    </Modal>
  );
}

DocumentPreviewModal.propTypes = {
  fileUrl: PropTypes.string,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  opened: PropTypes.bool.isRequired,
};

DocumentPreviewModal.defaultProps = {
  fileUrl: '',
  isLoading: false,
};
